import {z} from "zod";

const schema = z.object({
	roadNameAddress: z.string().nullable().default(""),
	jibunAddress: z.string().nullable().default("")
});

const model = schema.transform((values) => ({
	...values
}));

export const AddressModel = {schema, model};
export type IAddressModel = z.infer<typeof AddressModel.model>;
export const DEFAULT_ADDRESS: IAddressModel = {
	roadNameAddress: "",
	jibunAddress: ""
};
